




































































































import Component, {mixins} from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import RecurrenceUtils from "../../utils/recurrenceUtils";
import {Abonnement, Destinataire, RecurrenceRule} from "@/shared/Recurrence";
import ErrorMixin from "@/mixins/errorMixins";
import DestinationAdder from "@/config/recurrences/destinationAdder.vue";

@Component({
  components: {
    DestinationAdder,
  },
})
export default class AbonnementsRecurrences extends mixins(ErrorMixin) {
  @Prop() public listAbo!: Abonnement[];
  @Prop() public listDests!: Destinataire[];
  @Prop() public listRules!: RecurrenceRule[];

  public adding = false;
  public loading = false;

  public selectedAbo: Abonnement = new Abonnement();
  public dialogSupprAbo = false;

  public isSelected(abo: Abonnement) {
    return this.selectedAbo.id && this.selectedAbo.id === abo.id;
  }

  public prepareAddAbo() {
    this.selectedAbo = new Abonnement();
    this.adding = true;
  }

  public addRegle(event: string) {
    const regle = this.listRules.find((rule: any) => rule.id === event);

    if (regle !== undefined) {
      this.selectedAbo.regleExportable = regle;
    }
  }

  /**
   * Méthode permettant d'ajouter un nouvel abonnement
   */
  public async addAbo() {
    if (this.selectedAbo.regleDestinations.length === 0) {
      const err =
          this.$t("Destinataire").toString() +
          " " +
          this.$t("manquant").toString();
      this.setErrorFromTxt(err);
      this.loading = false;
      return;
    }

    if (this.selectedAbo.regleExportable.id === "") {
      const err =
          this.$t("Recurrences").toString() +
          " " +
          this.$t("manquant").toString();
      this.setErrorFromTxt(err);
      this.loading = false;
      return;
    }

    if (this.selectedAbo.regleDestinations.length > 0) {
      this.selectedAbo.regleDestinations.map((dest: any) => {
        this.addOne(dest);
      });
    }
  }

  /*
   * Méthode permettant de supprimer un abonnement
   */
  public async deleteAbo() {
    this.loading = true;
    this.$emit("deleteAbo", this.selectedAbo);
    this.dialogSupprAbo = false;
    this.loading = false;
  }

  public selectAbo(abo: Abonnement) {
    this.selectedAbo = abo;
  }

  private async addOne(destination: any) {
    await RecurrenceUtils.addAbo({
      ruleAboID: this.selectedAbo.regleExportable.id,
      destAbo: destination,
    }).then((response: any) => {
      this.setSuccess(this.$t("aboAdded").toString());
      this.$emit("addAbo", this.selectedAbo);
      this.loading = false;
    });
  }
}
